import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { RadioButton } from 'primereact/radiobutton';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';
import { booleanOptions } from 'constants/dropdownOptions';

export default function Boolean({
  handleSettingsClick,
  item,
  index,
  isFormBuilder,
  relationFieldName,
  isRelation = false,
  isFromPreview = false,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { subtext, required, label = 'Boolean' } = item || {};
  const name = isRelation ? relationFieldName : `form_data.${index}.value`;
  const _label = item?.res_type === 'custom-field' ? item?.name : label;

  return (
    <div className="w-100">
      <LabelName>
        {_label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex flex-row align-items-start flex-wrap">
        <Controller
          name={name}
          control={control}
          rules={
            isFormBuilder
              ? {}
              : {
                  validate: (value) => !required || typeof value === 'boolean' || 'Required Field',
                }
          }
          render={({ field, fieldState }) => (
            <>
              {booleanOptions.map((option, i) => (
                <div key={i} className="d-flex me-5 p-field-checkbox mt-2 cursor-pointer">
                  <RadioButton
                    id={name}
                    inputId={name + i}
                    value={option.value}
                    onChange={(e) => field.onChange(e.value)}
                    checked={field.value === option.value}
                    className={classNames({ 'p-invalid': fieldState.invalid })}
                    style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
                    inputRef={isFormBuilder ? null : field.ref}
                  />
                  <label htmlFor={name + i} className="ms-1 cursor-pointer p-checkbox-label">
                    {option.label}
                  </label>
                </div>
              ))}
            </>
          )}
        />
      </div>
      <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
      <RequiredValidation field={name} errors={errors} message="Required Field" />
    </div>
  );
}
